import {Box, styled, useTheme} from "@mui/material";
import React from "react";
import {Link} from "react-router-dom";

//note styled props
const StyledCaption = styled(Box)<{color?: string}>(({theme, color}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  marginBottom: "-20px",
  width: "100%",
  padding: "16px",
  color: "#fff",
  backgroundColor: color || "#444",
  borderRadius: "12px 0 12px 0",
  boxShadow: "5px 5px 10px rgb(0,0,0,0.3)",

  "& svg": {
    marginRight: "10px",
  },
  "& .addIcon": {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    color: "white",
    fontSize: "14px",
  },
}));

type CaptionProps = {
  title: string;
  color?: string;
  icon: React.ReactNode;
  link?: string;
  children?: React.ReactNode;
};

const MWCaption = ({title, color, icon, link, children}: CaptionProps) => {
  const theme = useTheme();
  return (
    <StyledCaption color={color}>
      {icon}
      {link === undefined ? (
        title
      ) : (
        <Link
          style={{color: theme.palette.background.paper, textDecoration: "underline"}}
          to={link}
        >
          {title}
        </Link>
      )}
      {children}
    </StyledCaption>
  );
};

export default MWCaption;
